"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProviderImageTooltipText = exports.Card = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const action_card_1 = require("@kyruus/action-card");
exports.Card = (0, styled_1.default)(action_card_1.ActionCard) ``;
exports.ProviderImageTooltipText = (0, styled_1.default)('div') `
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;
  justify-content: flex-start;
`;
//# sourceMappingURL=MiniProviderBookAndReferCard.styles.js.map